// extracted by mini-css-extract-plugin
export default {"modalBtn":"ModalStyle_modalBtn__ishgl"};